import { render, staticRenderFns } from "./EventAppointmentDetails.vue?vue&type=template&id=707bbcee&scoped=true&"
import script from "./EventAppointmentDetails.vue?vue&type=script&lang=ts&"
export * from "./EventAppointmentDetails.vue?vue&type=script&lang=ts&"
import style0 from "./EventAppointmentDetails.vue?vue&type=style&index=0&id=707bbcee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707bbcee",
  null
  
)

export default component.exports